// v78 — the four small charts of the profile panels.
const CY = "#00F0FF";
const MUTED = "rgba(255,255,255,0.08)";

function Row({ label, value, color, testid }) {
  const full = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div className="flex items-center gap-4" data-testid={testid} data-filled={full}>
      <span className="mono text-[10px] uppercase tracking-[0.18em] text-zinc-500 w-20 shrink-0">{label}</span>
      <div className="grid gap-[3px] flex-1 max-w-[322px]" style={{ gridTemplateColumns: "repeat(25, minmax(0, 10px))" }}>
        {Array.from({ length: 100 }, (_, i) => (
          <span key={i} className="w-full aspect-square rounded-[2px] c360-sq" style={{ background: i < full ? color : MUTED, animationDelay: `${i * 4}ms` }} />
        ))}
      </div>
    </div>
  );
}

export function Waffle({ them, typ }) {
  return (
    <div className="space-y-3" data-testid="c360-chart-waffle">
      <Row label="Them" value={them} color={CY} testid="c360-waffle-them" />
      <Row label="Typical" value={typ} color="#71717A" testid="c360-waffle-typ" />
    </div>
  );
}

export function Gauge({ them, typ }) {
  const r = typ ? them / typ : 1;
  const deg = Math.max(-90, Math.min(90, Math.log2(Math.max(r, 0.01)) * 45));
  return (
    <div className="flex justify-center" data-testid="c360-chart-gauge" data-angle={Math.round(deg)}>
      <svg viewBox="0 0 220 124" className="w-[260px] max-w-full">
        <path d="M 20 110 A 90 90 0 0 1 200 110" fill="none" stroke={MUTED} strokeWidth="14" strokeLinecap="round" />
        <path d="M 20 110 A 90 90 0 0 1 110 20" fill="none" stroke="rgba(244,63,94,0.25)" strokeWidth="14" strokeLinecap="round" />
        <path d="M 110 20 A 90 90 0 0 1 200 110" fill="none" stroke="rgba(57,255,20,0.25)" strokeWidth="14" strokeLinecap="round" />
        <line x1="110" y1="10" x2="110" y2="34" stroke="#A1A1AA" strokeWidth="2" strokeDasharray="3 3" />
        <g style={{ transform: `rotate(${deg}deg)`, transformOrigin: "110px 110px", transition: "transform 600ms cubic-bezier(.2,.8,.2,1)" }}>
          <line x1="110" y1="110" x2="110" y2="30" stroke={CY} strokeWidth="3" strokeLinecap="round" />
        </g>
        <circle cx="110" cy="110" r="6" fill={CY} />
        <text x="18" y="122" fill="#71717A" fontSize="9" fontFamily="monospace">lower</text>
        <text x="178" y="122" fill="#71717A" fontSize="9" fontFamily="monospace">higher</text>
      </svg>
    </div>
  );
}

const CAP = 50;
function Squares({ label, value, color, testid }) {
  const v = Math.max(0, value || 0);
  const n = Math.min(CAP, Math.ceil(v));
  return (
    <div className="flex items-center gap-4" data-testid={testid}>
      <span className="mono text-[10px] uppercase tracking-[0.18em] text-zinc-500 w-20 shrink-0">{label}</span>
      <div className="flex flex-wrap gap-[4px] max-w-[460px]">
        {Array.from({ length: n }, (_, i) => {
          const part = Math.min(1, v - i);
          return (
            <span key={i} className="w-[16px] h-[16px] rounded-[3px] overflow-hidden c360-sq" style={{ background: MUTED, animationDelay: `${i * 15}ms` }}>
              <span className="block h-full" style={{ width: `${part * 100}%`, background: color }} />
            </span>
          );
        })}
        {v > CAP && <span className="mono text-[10px] text-zinc-500 self-center">+{Math.round(v - CAP)}</span>}
        {!n && <span className="mono text-[10px] text-zinc-500">none</span>}
      </div>
    </div>
  );
}

export function WeekSquares({ them, typ }) {
  return (
    <div className="space-y-3" data-testid="c360-chart-weeks">
      <Squares label="Them" value={them} color={CY} testid="c360-weeks-them" />
      <Squares label="Typical" value={typ} color="#71717A" testid="c360-weeks-typ" />
    </div>
  );
}

export function TwoBars({ rows, fmt }) {
  const max = Math.max(...rows.map((r) => r[1] || 0), 1);
  return (
    <div className="space-y-3" data-testid="c360-chart-bars">
      {rows.map(([label, v], i) => (
        <div key={label} className="flex items-center gap-4">
          <span className="mono text-[10px] uppercase tracking-[0.12em] text-zinc-500 w-40 shrink-0 truncate">{label}</span>
          <div className="flex-1 h-6 rounded-sm" style={{ background: MUTED }}>
            <div className="h-full rounded-sm c360-grow" style={{ width: `${Math.max(1.5, ((v || 0) * 100) / max)}%`, background: i === 0 ? CY : "#71717A" }} />
          </div>
          <span className="mono text-xs text-zinc-200 w-16 text-right">{fmt(v)}</span>
        </div>
      ))}
    </div>
  );
}
